import type { LucideIcon } from 'lucide-react';

import type { PageContext } from '@/types/pageContext';

import { PAGE_SHORTCUTS } from './pageShortcuts';
import { TOOL_SHORTCUTS } from './toolShortcuts';

export type ShortcutCondition =
  | 'always'
  | 'populated'
  | 'has-hypotheses'
  | 'no-hypotheses'
  | 'health-score-gte-30'
  | 'low-maturity'
  | 'multiple-versions'
  | 'first-visit';

export interface Shortcut {
  id: string;
  order: number;
  icon: LucideIcon;
  label: string;
  prompt: string;
  condition: ShortcutCondition;
}

export const getShortcuts = (pageContext: PageContext): Shortcut[] => {
  if (pageContext.pageType === 'tool') {
    return TOOL_SHORTCUTS[pageContext.toolId] ?? [];
  }

  return PAGE_SHORTCUTS[pageContext.pageType] ?? [];
};
